import React, { useEffect, useState } from "react";
import { Container,  Row, Col } from "react-bootstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import BtnLoader from "../BtnLoader";
import { set } from "react-hook-form";
import ReactTost from "../ReactTost";
const RateLimit = () => {
  const [updateId, setUpdateId] = useState(0);
  const [limit, setLimit] = useState();
  const [seconds, setSeconds] = useState();
  const [errorDisplay, setErrorDisplay] = useState();

  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const {t} = useTranslation();
  const [loading,setLoading] = useState(false);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
 
  const [showAlert, setShowAlert] = useState(false);
  function SaveData(e) {
    e.preventDefault();
    let maxQuestion = limit;
    let msgLimit = seconds;
    let msgErr = errorDisplay;
  
    if (updateId) {
      setLoading(true);
      axios
        .patch(
          `${API_URL}/${API_VERSION}/rateLimit/${updateId}`,
          {
            maxQuestion,
            msgLimit,
            msgErr,
            
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          setType("Success");
          setMessage(t("Data updated successfully."));
          setShowAlert(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } else {
      setLoading(true);
      axios
        .post(
          `${API_URL}/${API_VERSION}/rateLimit`,
          {
            maxQuestion,
            msgLimit,
            msgErr,
            
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setType("Success");
          setMessage(t("Data added successfully."));
          setShowAlert(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }

  useEffect(() => {
    axios
      .get(`${API_URL}/${API_VERSION}/rateLimit`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.data.length) {
          setLimit(response.data[0].maxQuestion);
          setSeconds(response.data[0].msgLimit);
          setErrorDisplay(response.data[0].msgErr);
        
          setUpdateId(response.data[0].id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_URL, API_VERSION]);

  return (
    <>
     <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <section className="client_main">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} md={10} sm={12}>
              <div className="boxwrap">
                <h1>{t("Rate limit")}</h1>
                <p className="mb-3">{t("Enter the information for rate limit.")}</p>
                <Row>
                  <Col md={12}>
                    <div className="form-group mb-3">
                      <label
                        className="d-flex align-items-center gap-3 rate_limit"
                        htmlFor=""
                      >
                        {t("Limit to only")}{" "}
                        <input
                          type="number"
                          className="form-control d-inline"
                          style={{ width: "100px" }}
                          id="limit"
                          name="limit"
                          value={limit}
                          onChange={(event) => setLimit(event.target.value)}
                        />{" "}
                        {t("messages every")}{" "}
                        <input
                          type="number"
                          className="form-control d-inline"
                          style={{ width: "100px" }}
                          id="seconds"
                          name="seconds"
                          value={seconds}
                          onChange={(event) => setSeconds(event.target.value)}
                        />{" "}
                        {t("seconds")}
                      </label>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="form-group mb-3">
                      <label htmlFor="">
                        {t("Show this message to show when limit is hit")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="errorDisplay"
                        name="errorDisplay"
                        value={errorDisplay}
                        onChange={(event) =>
                          setErrorDisplay(event.target.value)
                        }
                      />
                    </div>
                  </Col>
               
                </Row>
                <div className="text-start mb-4">
                  <button
                    className="button px-4 py-3"
                    onClick={(e) => SaveData(e)}
                    disabled={loading}
                  > {loading?(<BtnLoader/>) : (t("Save / Update"))} </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RateLimit;
